<organization-top-navbar></organization-top-navbar>
<section class="img-container text-center img-fluid my-5">
  <img src="../../../assets/img/thumbnail_Flygets-logo.png" class="mx-auto d-block" alt="logo"
    class="width-50-max-500">
  <div class="centered my-5">
    <h1>{{ 'FLYGETS.WELCOME.TITLE' | transloco }}</h1>
    <p class="lead">{{ 'FLYGETS.WELCOME.BODY' | transloco }}</p>
  </div>
  <mat-divider class="my-5"></mat-divider>
  <app-itinerary [organizationId]="'a848ccd3-fd8d-4035-925e-571ebb4e93e8'"></app-itinerary>
  <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
  <h2>{{ 'FLYGETS.CENTRAL.TITLE' | transloco }}</h2>
  <p class="lead">{{ 'FLYGETS.CENTRAL.BODY1' | transloco }}</p>
  <p class="lead">{{ 'FLYGETS.CENTRAL.BODY2' | transloco }}</p>
  <p class="lead">{{ 'FLYGETS.CENTRAL.BODY3' | transloco }}</p>
  <p class="lead">{{ 'FLYGETS.CENTRAL.BODY4' | transloco }} <a [routerLink]="['/flygets/hitta-hit']">{{
      'FLYGETS.CENTRAL.LOCATIONLINK' | transloco }}</a></p>
  <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
  <div class="container-fluid">
    <h2>{{ 'FLYGETS.PRICEEXAMPLE.TITLE' | transloco }}</h2>
    <div class="row">
      <div class="col-md mb-4">
        <div class="card shadow" routerLink="/flygets-start">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal text-center">{{ 'FLYGETS.PRICEEXAMPLE.1DAY' | transloco }}</h4>
          </div>
          <div class="card-body">
            <h1 class="card-title pricing-card-title text-center">190 <small class="text-muted">SEK</small></h1>
            <!-- <p class="text-muted text-center">{{ 'FLYGETS.PRICEEXAMPLE.1DAYTEXT' | transloco }}</p> -->
          </div>
        </div>
      </div>

      <div class="col-md mb-4">
        <div class="card shadow" routerLink="/flygets-start">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal text-center">{{ 'FLYGETS.PRICEEXAMPLE.1WEEK' | transloco }}</h4>
          </div>
          <div class="card-body">
            <h1 class="card-title pricing-card-title text-center">{{ 'FLYGETS.PRICEEXAMPLE.APROX' | transloco }} 650
              <small class="text-muted">SEK</small>
            </h1>
            <!-- <p class="text-muted text-center">{{ 'FLYGETS.PRICEEXAMPLE.1WEEKTEXT' | transloco }}</p> -->
          </div>
        </div>
      </div>

      <div class="col-md mb-4">
        <div class="card shadow" routerLink="/flygets-start">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal text-center">{{ 'FLYGETS.PRICEEXAMPLE.2WEEK' | transloco }}</h4>
          </div>
          <div class="card-body">
            <h1 class="card-title pricing-card-title text-center">{{ 'FLYGETS.PRICEEXAMPLE.APROX' | transloco }} 930
              <small class="text-muted">SEK</small>
            </h1>
            <!-- <p class="text-muted text-center">{{ 'FLYGETS.PRICEEXAMPLE.2WEEKTEXT' | transloco }}</p> -->
          </div>
        </div>
      </div>

    </div>
  </div>
  <mat-divider class="my-5"></mat-divider>
</section>

<section #target>
  <div class="container">
    <h2>{{ 'FLYGETS.BOOKING.TITLE' | transloco }}</h2>
    <p class="lead">{{ 'FLYGETS.BOOKING.BODY1_2' | transloco }}</p>
    <h2>{{ 'FLYGETS.BOOKING.TITLE2' | transloco }}</h2>
    <p class="lead">{{ 'FLYGETS.BOOKING.BODY2' | transloco }} <a href="/kund">www.flygets.se/kund</a></p>
    <p class="lead"><strong>{{ 'FLYGETS.BOOKING.TITLE3' | transloco }}</strong></p>
    <h2>{{ 'FLYGETS.BOOKING.SELFSERVICETITLE' | transloco }}</h2>
    <p class="lead">{{ 'FLYGETS.BOOKING.SELFSERVICETEXT' | transloco }} <a
        href="/self-service">www.flygets.se/self-service</a></p>
    <h2>{{ 'FLYGETS.BOOKING.TITLE4' | transloco }}</h2>
    <p class="lead">{{ 'FLYGETS.BOOKING.BODY3' | transloco }}</p>
    <p class="lead"><a [routerLink]="['/flygets/faq']">{{ 'FLYGETS.BOOKING.BODY4' | transloco }}</a></p>

  </div>

  <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
  <section>
    <h2>{{ 'FLYGETS.BOOKING.CANCELATION.TITLE' | transloco }}</h2>
    <p class="lead">{{ 'FLYGETS.BOOKING.CANCELATION.BODY1' | transloco }} <a href="/kund">www.flygets.se/kund</a></p>
  </section>
  <mat-divider class="my-5"></mat-divider>

  <section>
    <h2>{{ 'FLYGETS.TRANSFER.TITLE' | transloco }}</h2>
    <p class="lead">{{ 'FLYGETS.TRANSFER.BODY1' | transloco }}</p>
    <p class="lead">{{ 'FLYGETS.TRANSFER.BODY2' | transloco }}</p>
    <p class="lead">{{ 'FLYGETS.TRANSFER.BODY3' | transloco }}</p>
  </section>

  <mat-divider class="my-5"></mat-divider>
  <section>
    <h2>{{ 'FLYGETS.SOCIAL.TITLE' | transloco }}</h2>
    <p class="lead">{{ 'FLYGETS.SOCIAL.BODY' | transloco }} <a href="https://www.matchedin.se"
        target="_blank">www.matchedin.se</a></p>
  </section>
</section>

<section class="container">
  <div class="row text-center">
    <div class="col-lg-3 clickable" (click)="scrollToElement(target)">
      <img src="../../../assets/img/boka1.png" alt="booking-image">
      <h2 class="my-4">{{ 'FLYGETS.ACTIONS.BOOKING.TITLE' | transloco }}</h2>
      <p class="lead">{{ 'FLYGETS.ACTIONS.BOOKING.TEXT' | transloco }}</p>
    </div>

    <div class="col-lg-3 clickable" [routerLink]="['/flygets/priser']">
      <img src="../../../assets/img/priser1.png" alt="pricing-image">
      <h2 class="my-4">{{ 'FLYGETS.ACTIONS.PRICES.TITLE' | transloco }}</h2>
      <p class="lead">{{ 'FLYGETS.ACTIONS.PRICES.TEXT' | transloco }}</p>
    </div>

    <div class="col-lg-3 clickable" [routerLink]="['/flygets/kontakta-oss']">
      <img src="../../../assets/img/tjanster1.png" alt="contact-image">
      <h2 class="my-4">{{ 'FLYGETS.ACTIONS.CONTACT.TITLE' | transloco }}</h2>
      <p class="lead">{{ 'FLYGETS.ACTIONS.CONTACT.TEXT' | transloco }}</p>
    </div>

    <div class="col-lg-3 clickable" [routerLink]="['/flygets/hitta-hit']">
      <img src="../../../assets/img/hitta_hit1.png" alt="pricing-image">
      <h2 class="my-4">{{ 'FLYGETS.ACTIONS.FINDUS.TITLE' | transloco }}</h2>
      <p class="lead">{{ 'FLYGETS.ACTIONS.FINDUS.TEXT' | transloco }}</p>
    </div>
  </div>
</section>


<div class="jumbotron jumbotron-fluid mt-4">
  <div class="container">
    <p class="lead">{{ 'FLYGETS.CONTACT.TEXT1' | transloco }}</p>
    <a [routerLink]="['/flygets/kontakta-oss']">{{ 'FLYGETS.CONTACT.FORM' | transloco }}</a><br>
    <a href="mailto: info@flygets.se">info&#64;flygets.se</a><br>
    <a href="tel: 010-330 03 33"> 010-330 03 33</a>
    <p class="lead">{{ 'FLYGETS.CONTACT.TEXT3' | transloco }}</p>
  </div>
</div>

<div class="container">
  <h2>{{ 'FLYGETS.PARTNERS' | transloco }}</h2>
  <div class="row mt-5 text-center">
    <div class="col-6">
      <img class="img-fluid" src="../../../assets/img/Ving_logo_primary_orange_RGB-768x177.png" alt="ving-image">
    </div>
    <div class="col-6">
      <img class="img-fluid" src="../../../assets/img/TUI_rgb_positive_1300.png" alt="tui-image">
    </div>
  </div>
</div>

<app-small-footer></app-small-footer>